import DataObjectList from '../../../common/model/DataObjectList';

import DataConnector from './DataConnector';

export default class DataConnectorList extends DataObjectList {
  getElementClassType() {
    return DataConnector;
  }
}